var prodcat = window.prodcat || {};
var site = window.site || {};

prodcat.data = prodcat.data || {};
site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.productUIWShadesV1 = {
    attach: function (context) {
      var self = this;

      $('.js-product-uiw-shades', context).each(function () {
        self.init($(this));
      });
    },

    init: function ($component) {
      var self = this;

      $component.find('.js-product-uiw-shades-trigger')
        .once('uiw-shades-trigger')
        .on('click keydown', function (e) {
          if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            self.openOverlay($component);
          }
        });

      self.selectInitial($component);
    },

    selectInitial: function ($component) {
      var currentSku = $component.attr('data-sku-base-id') || $component.data('skuBaseId');
      var $overlayTemplate = $component.find('.js-product-uiw-shades-overlay');
      var $shadeLinks = $overlayTemplate.find('.js-product-uiw-shade-link');

      if (!$shadeLinks.length) {
        return;
      }

      var firstSku = currentSku ||
        $shadeLinks.first().attr('data-sku-base-id') ||
        $shadeLinks.first().data('skuBaseId');

      if (!firstSku) {
        return;
      }

      this.applySelection($component, firstSku);
    },

    openOverlay: function ($component) {
      var self = this;
      var currentSku = $component.attr('data-sku-base-id') || $component.data('skuBaseId');
      var $template = $component.find('.js-product-uiw-shades-overlay').first();

      if (!$template.length) {
        return;
      }

      var overlayHeight = $template.outerHeight(true);
      var $overlayClone = $template.clone(true).addClass('active is-active');
      var $shell = $('<div/>').addClass('product-uiw__overlay-shell').append($overlayClone);

      $overlayClone.data('originRoot', $component);

      var options = {
        content: $shell,
        className: 'product-uiw__shades-overlay js-shades-overlay',
        fixed: true,
        bottom: 0,
        maxHeight: overlayHeight,
        closeButton: false,
        hideOnClickOutside: true,
        onComplete: function () {
          $('html').addClass('overlay-open');
          self.onOverlayReady($overlayClone, $component, currentSku);
        },
        onClosed: function () {
          $('html').removeClass('overlay-open');
        }
      };

      if (window.generic?.overlay?.launch) {
        // eslint-disable-next-line no-undef
        generic.overlay.launch(options);
      } else {
        $component.append($shell);
        this.onOverlayReady($overlayClone, $component, currentSku);
      }
    },

    onOverlayReady: function ($overlay, $cardComponent, currentSku) {
      var self = this;
      var $grid = $overlay.find('.js-product-uiw-shades-grid');

      if ($grid.length && $.fn.slick && !$grid.hasClass('slick-initialized')) {
        $grid.slick({
          infinite: false,
          autoplay: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 0,
          swipe: true,
          slide: '.product-uiw-shades__item'
        });

        if (currentSku) {
          var targetIndex = 0;

          $grid.find('.js-product-uiw-shade-link').each(function (i) {
            var skuId = $(this).attr('data-sku-base-id') || $(this).data('skuBaseId');

            if (String(skuId) === String(currentSku)) {
              targetIndex = i;

              return false;
            }
          });
          try {
            $grid.slick('slickGoTo', targetIndex, true);
          } catch (e) {
            return e;
          }
        }
      }

      var initSku = currentSku ||
        ($overlay.find('.js-product-uiw-shade-link').first().attr('data-sku-base-id') || null);

      if (initSku) {
        this.applySelection($overlay, initSku);
      }

      $overlay
        .off('click.uiw keydown.uiw', '.js-product-uiw-shade-link')
        .on('click.uiw keydown.uiw', '.js-product-uiw-shade-link', function (e) {
          if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var skuBaseId = $(this).attr('data-sku-base-id') || $(this).data('skuBaseId');

            if (!skuBaseId) {
              return;
            }
            self.applySelection($overlay, skuBaseId);
            self.applySelection($cardComponent, skuBaseId);
          }
        });

      $overlay.find('.js-product-uiw-shades-close')
        .off('click.uiw')
        .on('click.uiw', function (e) {
          e.preventDefault();
          if (window.generic?.overlay?.hide) {
            // eslint-disable-next-line no-undef
            generic.overlay.hide();
          } else {
            $overlay.closest('.product-uiw__overlay-shell').remove();
          }
        });
    },

    applySelection: function ($context, skuBaseId) {
      if (!skuBaseId) {
        return;
      }

      var skuData = this.getSku(skuBaseId);
      var $shadeLinks = $context.find('.js-product-uiw-shade-link');
      var $shadeWrapper = $context;

      if ($shadeLinks.length) {
        $shadeLinks.attr('aria-selected', false).removeClass('is-selected');
        $shadeLinks.filter('[data-sku-base-id="' + skuBaseId + '"]')
          .attr('aria-selected', true).addClass('is-selected');
      }

      if (skuData?.SHADENAME) {
        $context.find('.js-product-uiw-shade-name').html(skuData.SHADENAME);
      }
      if (skuData?.HEX_VALUE_STRING) {
        $context.find('.js-product-uiw-shade-dot').css('background-color', skuData.HEX_VALUE_STRING);
      }

      this.updateOverlayHeaderAndPrice($context, skuData);
      this.updateAddToBag($context, skuBaseId);

      if ($context.hasClass('js-product-uiw-shades')) {
        $context.attr('data-sku-base-id', skuBaseId);
      }

      var $originCard = $context.data('originRoot');

      if ($originCard && $originCard.length) {
        var $shadesWrapper = $originCard.closest('.js-use-it-with-atb-info');

        this.updateAddToBag($shadesWrapper, skuBaseId);
        $originCard.attr('data-sku-base-id', skuBaseId);
        if (skuData?.SHADENAME) {
          $originCard.find('.js-product-uiw-shade-name').html(skuData.SHADENAME);
        }
        if (skuData?.HEX_VALUE_STRING) {
          $originCard.find('.js-product-uiw-shade-dot').css('background-color', skuData.HEX_VALUE_STRING);
        }
        if (skuData?.IMAGE_MEDIUM_COMBINED[0]) {
          $shadesWrapper.prev('.js-use-it-with-img-wrap').find('img').attr('src', skuData?.IMAGE_MEDIUM_COMBINED[0]);
        }
      }
      if (!$context.hasClass('js-product-uiw-shades-overlay')) {
        $shadeWrapper = $context.closest('.js-use-it-with-atb-info');
      }
      $(document).trigger('useitwith.updateInventory', [$shadeWrapper, skuData]);
    },

    updateOverlayHeaderAndPrice: function ($node, skuData) {
      if (!skuData) {
        return;
      }

      $node.find('.js-product-uiw-shades__name').html(skuData.SHADENAME || '');
      $node.find('.js-product-uiw-shades__description').html(skuData.SHADE_DESCRIPTION || '');
      $node.find('.js-product-uiw-shades__badge').text(skuData.MISC_FLAG_TEXT || '');
      if (skuData.HEX_VALUE_STRING) {
        $node.find('.js-product-uiw-shades__hex').css('background', skuData.HEX_VALUE_STRING);
      }

      var $priceWrap = $node.find('.js-product-price');

      if ($priceWrap.length) {
        var $newPrice = $priceWrap.find('.js-new_price, .price');
        var $oldPrice = $priceWrap.find('.js-old_price, .old_price');

        if ($newPrice.length) {
          $newPrice.text(skuData.formattedPrice || '');
        }
        if ($oldPrice.length && skuData.PRICE2) {
          $oldPrice.text(skuData.formattedPrice2);
          $priceWrap.addClass('price-discount');
        } else {
          $oldPrice.text('');
          $priceWrap.removeClass('price-discount');
        }
      }
    },

    updateAddToBag: function ($node, skuBaseId) {
      $node.find('.js-use-with-atb-link, .js-use-with-atb').attr('data-sku-base-id', skuBaseId);
    },

    getSku: function (skuBaseId) {
      try {
        return (window.prodcat?.data?.getSku) ? (prodcat.data.getSku(skuBaseId) || null) : null;
      } catch (e) {
        return e;
      }
    }
  };
})(jQuery);
